// Dependency-free auth constants. The router reads CognitoGroups while its route
// table evaluates, so these must not live in auth.store.js, which sits in the
// auth.store -> auth.api -> httpClient -> router import cycle.
export const MFA_STAGES = {
  ENTER_USER_CREDS: 'ENTER_USER_CREDS',
  SMS_MFA: 'SMS_MFA',
  SOFTWARE_TOKEN_MFA: 'SOFTWARE_TOKEN_MFA',
  SELECT_MFA_TYPE: 'SELECT_MFA_TYPE',
  NEW_PASSWORD_REQUIRED: 'NEW_PASSWORD_REQUIRED',
  LOGIN_SUCCESS: 'LOGIN_SUCCESS'
}

export const CognitoGroups = {
  FINANCIAL_MANAGER: 'FinancialManager',
  ACCOUNT_MANAGER_ADMIN: 'AccountManagerAdmin',
  ACCOUNT_MANAGER: 'AccountManager',
  ADMIN: 'Admin'
}

export const PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[\^$*.[\]{}()?\-"!@#%&/,><':;|_~`])\S{8,99}$/
